import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import page404Poster from '../../images/page404.png';
import styles from '../../styles/NotFound.module.scss';

const PAGE404_VIDEO = `${process.env.PUBLIC_URL}/videos/page404.mp4`;

const prefersReducedMotion = () => (
  typeof window !== 'undefined'
  && window.matchMedia('(prefers-reduced-motion: reduce)').matches
);

const NotFound = () => {
  const videoRef = useRef(null);
  const [usePosterFallback, setUsePosterFallback] = useState(prefersReducedMotion);

  useEffect(() => {
    document.title = '404 — Сторінку не знайдено | Інтернет-магазин';
    return () => {
      document.title = 'Інтернет-магазин';
    };
  }, []);

  useEffect(() => {
    if (usePosterFallback) return undefined;

    const video = videoRef.current;
    if (!video) return undefined;

    const playVideo = () => {
      video.play().catch(() => setUsePosterFallback(true));
    };

    playVideo();
    video.addEventListener('loadeddata', playVideo);

    return () => {
      video.removeEventListener('loadeddata', playVideo);
    };
  }, [usePosterFallback]);

  return (
    <section className={styles.notFound}>
      <div className={styles.stage}>
        {!usePosterFallback ? (
          <video
            ref={videoRef}
            className={styles.engineVideo}
            src={PAGE404_VIDEO}
            poster={page404Poster}
            autoPlay
            loop
            muted
            playsInline
            preload="auto"
            aria-hidden="true"
            onError={() => setUsePosterFallback(true)}
          />
        ) : (
          <img
            src={page404Poster}
            alt=""
            className={styles.engineVideo}
            aria-hidden="true"
          />
        )}

        <div className={styles.lightSweep} aria-hidden="true" />
        <div className={styles.vignette} aria-hidden="true" />
        <div className={styles.bottomFade} aria-hidden="true" />
      </div>

      <div className={styles.panel}>
        <div className={styles.statusRow}>
          <span className={`${styles.statusDot} ${styles.statusBlink}`} />
          <span className={styles.statusText}>Check Engine · код 404</span>
        </div>

        <h1 className={styles.title}>Механічна несправність</h1>
        <p className={styles.subtitle}>
          Сторінка перегрілася і зникла з маршруту. Поверніться в автомагазин
          або знайдіть потрібну запчастину через пошук.
        </p>

        <div className={styles.actions}>
          <Link to="/" className={styles.primaryBtn}>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
              <path d="M3 10.5L12 3l9 7.5" strokeLinecap="round" strokeLinejoin="round" />
              <path d="M5 9.5V20h14V9.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
            На головну
          </Link>
          <Link to="/search" className={styles.secondaryBtn}>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
              <circle cx="11" cy="11" r="7" />
              <path d="M20 20l-4-4" strokeLinecap="round" />
            </svg>
            Пошук запчастин
          </Link>
        </div>
      </div>
    </section>
  );
};

export default NotFound;
